import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsClientEmailTemplateModel } from 'src/api/generated';

export const EMAIL_TEMPLATES_URI = 'email-templates';

export const emailTemplatesQueries = createQueryKeys(EMAIL_TEMPLATES_URI, {
  all: null,
  list: {
    queryKey: ['list'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientEmailTemplateModel[]>({ uri: EMAIL_TEMPLATES_URI });
      return response.data;
    },
  },
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientEmailTemplateModel>({
        uri: `${EMAIL_TEMPLATES_URI}/${id}`,
      });
      return response.data;
    },
  }),
});
